import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { PaypalButton } from './paypalButton'
import { ComponentPropsExtenderSymbol } from 'feature-components'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentPropsExtenderSymbol).to(PaypalButton)
}
